"use strict";

// Throttle does not allow our functions to execute more than once every X milliseconds.
// Different from Debounce throttle guarantees the execution of the function regularly, at least every X milliseconds.
// right now if you don't set the milliseconds it will default to 250

// this is a simple version orinally from https://lodash.com/docs/4.17.4#throttle

function Throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last = void 0;
  var deferTimer = void 0;
  return function () {
    var context = scope || this;

    var now = +new Date();
    var args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}